import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/FooterEnhanced';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import EULA from './pages/EULA';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataSecurity from './pages/DataSecurity';
import TermsOfUse from './pages/TermsOfUse';
import AIServices from './pages/services/AIServices';
import ITProjects from './pages/services/ITProjects';
import ManagedIT from './pages/services/ManagedIT';
import Helpdesk from './pages/services/Helpdesk';
import { initSmoothAnchorScroll, destroySmoothAnchorScroll } from './utils/smoothAnchorScroll';
import ErrorBoundary from './components/ErrorBoundary';
// import ExitIntentPopup from './components/ExitIntentPopup';
import ScrollToTop from './components/ScrollToTop';
import AIChat from './components/AIChat';
import Assessment from './pages/Assessment';

const MainContent = styled.main`
  padding-top: 80px; /* Space for fixed header */
  min-height: 100vh;
  
  @media (min-width: 768px) {
    padding-top: 90px;
  }
`;

function App() {
  useEffect(() => {
    // Prevent browser from restoring scroll position on refresh
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Initialize smooth scroll for anchor links only
    initSmoothAnchorScroll();
    
    // Cleanup on unmount
    return () => {
      destroySmoothAnchorScroll();
    };
  }, []);
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6Lf238MrAAAAAGTpgXwk4hGX4m0jT7a53Lgd66aW"}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
        nonce: undefined
      }}
    >
      <Router>
        <GlobalStyles />
        <ScrollToTop />
        {/* <ExitIntentPopup /> */}
        <div className="App">
          <Header />
          <ErrorBoundary>
            <MainContent>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/ai-solutions" element={<AIServices />} />
                <Route path="/services/it-projects" element={<ITProjects />} />
                <Route path="/services/managed-it" element={<ManagedIT />} />
                <Route path="/services/helpdesk" element={<Helpdesk />} />
                <Route path="/assessment" element={<Assessment />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/eula" element={<EULA />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/security" element={<DataSecurity />} />
                <Route path="/terms" element={<TermsOfUse />} />
              </Routes>
            </MainContent>
          </ErrorBoundary>
          <Footer />
          <AIChat />
        </div>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;